import type { Controller, Listeners } from '../helpers';
import { controllerHelpers } from '../helpers';
import type { UpdateBillingManager } from '../managers';
import { billingInfoFormEventBus } from '../managers';

export class BillingFormSubmissionActionsController implements Controller {
  public listeners: Listeners;

  constructor(private updateBillingManager: UpdateBillingManager) {
    this.listeners = controllerHelpers.createListeners([
      billingInfoFormEventBus.bindTo('formDirtyStateChanged', this.onDirtyStateChanged),
    ]);
  }

  private onDirtyStateChanged = async (dirtyState: boolean) => {
    const api = await this.updateBillingManager.getApiWhenReady();

    api.reportFormDirtyState(dirtyState);
  };
}
